/**
 * API Configuration
 * In production (DigitalOcean), REACT_APP_BACKEND_URL should be empty
 * so we use relative '/api' path which routes to the backend service.
 * In development, set REACT_APP_BACKEND_URL=http://localhost:8001
 */

export const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = API_BASE_URL ? `${API_BASE_URL}/api` : '/api';
